export default {
  methods: {
    trackPageReddit() {
      rdt('init', 't2_pd1aslc');
      rdt('track', 'SignUp');
    },
    trackPagePinterest() {
      pintrk('load', '2613205418059', {em: '<user_email_address>'});
      pintrk('page');
    }
  },
  //Register the tracking functions to the window object before any tracking attempts are made
  beforeMount() {
    const self = this;

    self.$nextTick(() => {
      //Reddit Conversion Tracking
      !function (w, d) {
        if (!w.rdt) {
          var p = w.rdt = function () {
            p.sendEvent ? p.sendEvent.apply(p, arguments) : p.callQueue.push(arguments)
          };
          p.callQueue = [];
          var t = d.createElement("script");
          t.src = "https://www.redditstatic.com/ads/pixel.js", t.async = !0;
          var s = d.getElementsByTagName("script")[0];
          s.parentNode.insertBefore(t, s)
        }
      }(window, document);
      //Pinterest Conversion Tracking
      !function (e) {
        if (!window.pintrk) {
          window.pintrk = function () {
            window.pintrk.queue.push(Array.prototype.slice.call(arguments))
          };
          var
            n = window.pintrk;
          n.queue = [], n.version = "3.0";
          var
            t = document.createElement("script");
          t.async = !0, t.src = e;
          var
            r = document.getElementsByTagName("script")[0];
          r.parentNode.insertBefore(t, r)
        }
      }("https://s.pinimg.com/ct/core.js");
    });
  }
}



// WEBPACK FOOTER //
// ./src/mixins/AnalyticsTrackingMixin/index.js